export default "/_next/static/chunks/fonts/Nunito-Regular-latin-175ed83c8bbe272ab7d846ad90a2c73e.woff2";